module.exports = __webpack_public_path__ + "static/media/refractor.8dc90f4b.jpg";